import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { typeFilters } from '../FiltersConstants.inner.js';

const RangeFilter = ({
  children,
  setFilterValue,
  filterValue,
  validate = () => false,
  currencyCode = 'ARS',
}) => {
  const getValue = () =>
    filterValue
      ? typeof filterValue == 'object'
        ? filterValue
        : [filterValue, filterValue]
      : null;
  const [rangeValues, setRangeValues] = useState(getValue());

  const hasChanges = () => {
    if (rangeValues && getValue()) {
      return rangeValues[0] != getValue()[0] || rangeValues[1] != getValue()[1];
    }
    return rangeValues != getValue();
  };

  useEffect(() => {
    hasChanges() && setRangeValues(getValue());
  }, [filterValue]);

  useEffect(() => {
    if (hasChanges()) {
      if (rangeValues && (rangeValues[0] || rangeValues[1])) {
        if (rangeValues[0] === rangeValues[1]) {
          setFilterValue({
            type: typeFilters.EQUALS,
            value: rangeValues[0],
            error: validate(rangeValues),
          });
        } else {
          setFilterValue({
            type: typeFilters.RANGE,
            value: Object.values(rangeValues).map((value) => value || ''),
            error: validate(rangeValues),
          });
        }
      } else {
        setFilterValue(null);
      }
    }
  }, [rangeValues]);

  const setFrom = (from) =>
    setRangeValues([from, rangeValues ? rangeValues[1] : '']);

  const setTo = (to) => setRangeValues([rangeValues ? rangeValues[0] : '', to]);

  const hasError = () => validate(rangeValues);

  return children({
    setFrom,
    setTo,
    fromValue: rangeValues ? rangeValues[0] : undefined,
    toValue: rangeValues ? rangeValues[1] : undefined,
    setRangeValues,
    error: hasError(),
    currencyCode,
  });
};

RangeFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired,
};

export default RangeFilter;
